<article class="box_default box_white">
  <!-- HEADER -->
  <header>
    <h3>Create a new user group</h3>
    <p>Write a group name and click on <strong>SAVE</strong>. The new group will appear on the <strong>CURRENT USER GROUPS</strong> section of the page.</p>
  </header>
  <!-- END HEADER -->
  <!-- BODY -->
  <div class="box_main">
    <form [formGroup]="form">
      <!-- <span class="txt_error" *ngIf="errorAddInvite">{{textError}}</span> -->
      <div class="box_item">
        <label class="box-label">GROUP NAME</label>
        <input type="text" placeholder="What name do you want to give to this group?" formControlName="name"/>
      </div>
      <div class="box_fieldset">
        <core-helpers-forms-button-white [disabled]="form.invalid" [text]="'Save'" (click)= "onSubmit()"></core-helpers-forms-button-white>
        <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
      </div>
    </form>
  </div>
</article>
